import { Button } from '@atomic/atm.button';
import { Color } from '@atomic/obj.constants';
import styled from 'styled-components';
export const UserLinkStyled = styled(Button) `
  color: ${Color.Black};
  text-decoration: none;
`;
